export const emailActionOperations = {
  verifyEmail: "VERIFY_EMAIL", resetPassword: "PASSWORD_RESET", recoverEmail: "RECOVER_EMAIL",
  verifyAndChangeEmail: "VERIFY_AND_CHANGE_EMAIL", revertSecondFactorAddition: "REVERT_SECOND_FACTOR_ADDITION"
} as const;
export type EmailActionMode = keyof typeof emailActionOperations;
export function parseEmailAction(search: string) {
  const query = new URLSearchParams(search), mode = query.get("mode"), code = query.get("oobCode");
  const locale = query.get("lang") === "en" ? "en" as const : "el" as const;
  if (!mode || !Object.hasOwn(emailActionOperations, mode) || !code || code.length > 2048 || !/^[a-zA-Z0-9_-]+$/.test(code)
    || query.getAll("mode").length !== 1 || query.getAll("oobCode").length !== 1) return { valid: false as const, locale };
  // Ignore caller-provided apiKey and continueUrl: configured project and fixed internal destinations only.
  return { valid: true as const, locale, mode: mode as EmailActionMode, code };
}
export function emailActionDestination(mode: EmailActionMode) {
  return mode === "verifyEmail" || mode === "verifyAndChangeEmail" ? "/billing" : "/login";
}
